export default "__VITE_ASSET__CO0_pTwm__"